import { Component, Output, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StateModule } from "projects/shared-state/lib/state.module";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, map } from "rxjs";
import { PostgenieHomeComponent } from "../home/home.component";
import { AuthService } from "@aihub/core/authorization";
import { toSignal } from "@angular/core/rxjs-interop";
import { AppProfileComponent } from "../app-profile/app-profile.component";
import { ResultProcessComponent } from "../result-process/result-process.component";
import { HeaderService } from "@shared/header/src/header.service";

@Component({
  standalone: true,
  selector: "postgenie-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  imports: [
    CommonModule,
    StateModule,
    AppProfileComponent,
    PostgenieHomeComponent,
    ResultProcessComponent,
  ],
})
export class PostgenieMainComponent {
  protected currentUrl: Observable<string>;
  private authService = inject(AuthService);
  private headerService = inject(HeaderService);
  private router = inject(Router);

  @Output() user = toSignal(this.authService.getUser());

  constructor(private activeRoute: ActivatedRoute) {
    this.currentUrl = this.activeRoute.url.pipe(
      map((segments) => "/" + segments.join("/")),
    );
    this.headerService.headerEvent$.subscribe({
      next: (event) => {
        if (event["eventName"] === "displayName")
          this.router.navigate(["profile"], {
            queryParamsHandling: "merge",
          });
      },
    });
  }
}
